import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {UserId} from '../types';

/**
 * `getUserLabel` request params
 * (what is used to send to server)
 */
export interface GetUserLabelRequestOptions {
	id: UserId;
}

/**
 * `getUserLabel` request
 * (what gets sent to the server)
 */
export type GetUserLabelRequest = [GetUserLabelRequestOptions['id']];

/**
 * `getUserLabel` response
 * (what comes back from the server)
 */
export type GetUserLabelResponse = SuccessResponse<GetUserLabelResult>;

/**
 * `getUserLabel` result
 * (what is utilized from the server response)
 */
export type GetUserLabelResult = string;

export const getUserLabelEndpoint = 'getUserLabel';

/**
 * Get user label by id
 * @param fetchParams Fetch params
 */
export const getUserLabel = async (
	{id}: GetUserLabelRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetUserLabelRequest = [id];

	return client
		.post<GetUserLabelResponse>(getUserLabelEndpoint, requestParams, {signal})
		.then((response) => response.data.result);
};
export default getUserLabel;
